<template>
  <div>
    <Error />
  </div>
</template>

<script>
import { layouts } from '../helpers'
import Error from '../components/Universal/Error'

export default {
  name: 'NotFound',
  components: { Error },
  created() {
    this.$store.dispatch('layout/setPageLayout', layouts.DEFAULT_LAYOUT)
  }
}
</script>
